import {Avatar, Button, DatePicker, Input, Space} from 'antd'
import FieldsFactory from 'components/form/FieldsFactory'
import FormActionBar from 'components/form/FormActionBar'
import {createValue} from 'components/form/utils'
import {Formik} from 'formik'
import {parseDayjs} from 'helpers/datetimeHelpers'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import withTranslate from 'modules/local/withTranslate'
import React, {useMemo} from 'react'
import {BsAspectRatio, BsCheckCircleFill, BsExclamationTriangleFill, BsImage, BsInfoCircle, BsPeopleFill, BsPersonCircle, BsShieldCheck} from 'react-icons/bs'
import {IoCalendarOutline, IoImageOutline} from 'react-icons/io5'
import {compose, mapProps} from 'recompose'
import {GenderTypes, IdentifierTypes} from 'views/AppLocals/appFieldTypes'
import {gConfigs} from 'views/AppLocals/configs'
import {createControlledFormField, createPhoneNumberField} from 'views/AppLocals/factory/createFormField'
import {NullAsDefault, shallowDiff} from 'views/Shared'
import Translate from '../../../../modules/local/Translate'
import AvatarUploader from '../../../Workspace/components/AvatarUploader'
import {appClassNames} from '../../custom/appClassNames'
import IdentifierCodeLookupField from '../../../../components/IdentifierCodeLookupField'
import {LayoutContext} from '../../../../components/layouts/Default/LayoutContext'
import LookupField from '../../../../components/LookupField'
import {renderIf, renderIfElse} from '../../../Shared'
import {RiMapPinFill, RiSearch2Line} from 'react-icons/ri'
import {MdChurch} from 'react-icons/md'
import {SaintsOutlineSvg} from '../../../../components/Svgs/SaintsPlaceholder'
import UserLookupComponent from '../../../../components/UserLookupComponent'
import {LinkedAccountBadge} from '../../../../components/UserLookupComponent/LinkedAccountBadge'
import Pure from '../../../../components/Pure'
import dayjs from 'dayjs'
import {ActionModalWrapper} from '../../../../components/form/ActionModalWrapper'
import {FaPhone, FaUserGraduate} from 'react-icons/fa6'
import {
    digitLength,
    emailFormat,
    firstLetterUppercase,
    lengthBetween,
    maximumAge,
    minimumAge,
    noDoubleSpaces,
    noLeadingTrailingSpaces,
    noNumber,
    noSpecialChars,
    notFutureDate,
    parishFormart,
    passportFormart,
    required,
    runRules,
    validDate,
} from '../../../../components/form/ValidateForm'
import {ChipGroup, Field, Section} from "../../../../components/form/ModernForm";
import {IDENTITY_STATUS} from "./components/StudentIdentitySection";
// import { error } from 'tailwindcss/lib/cli/utils'

export const formSchema = {
    avatar: {
        children: [
            {
                name: 'avatar',
                className: 'w-fit',
                component: createControlledFormField({
                    withValues: ({avatar_preview}) => ({
                        value: avatar_preview,
                        width: 150,
                        height: 150,
                        icon: (
                            <BsImage
                                size={70}
                                style={{color: '#eaeaea'}}
                            />
                        ),
                    }),
                    cropPurpose: 'avatar',
                    round: true,
                    Component: AvatarUploader,
                }),
            },
        ],
    },
    patron_saint__fullname: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-3 gap-3',
        itemClassNames: ['col-span-1', 'col-span-1 md:col-span-2'],
        children: [
            {
                label: 'holy name',
                name: 'patron_saint',
                component: ({name, value, onChange, form}) => (
                    <Translate>
                        {(t) => (
                            <LookupField
                                title={t('choose patron saint')}
                                createIfNotExists={true}
                                defaultValue={form?.values?.patron_saint_name}
                                selectedOption={form?.values?.patron_saint}
                                apiPath={`/lookup/saint/get-by-types`}
                                name={name}
                                OptionWrapper={({children, ...props}) => (
                                    <div className="p-3 flex items-center gap-2 lookup-item" {...props}>
                                        {children}
                                    </div>
                                )}
                                renderOption={(o, i) => {
                                    return (
                                        <div key={i} className="flex items-start flex-1 gap-3">
                                            <Avatar
                                                size={40}
                                                src={o.avatar}
                                                className="flex flex-center bg-secondary-50 rounded-lg"
                                                icon={<SaintsOutlineSvg size={20} className="text-secondary-500"/>}
                                            />
                                            <div className="flex flex-col flex-1">
                                                <span
                                                    className="font-bold text-sm text-color-000 tracking-wide leading-snug">
                                                    {`${o.common_name || o.name} (${o.patron_saint_feast_day || o.feast_day})`}
                                                </span>
                                                {renderIf(
                                                    o?.description,
                                                    <span
                                                        className="text-xs text-color-300 italic tracking-wider max-lines-1">
                                                        {o?.description}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    )
                                }}
                                handleChange={(e) => {
                                    form.setValues({
                                        ...form.values,
                                        patron_saint: e.target,
                                        patron_saint_name: e.target.common_name || e.target.value,
                                        patron_saint_feast_day: e.target.feast_day,
                                        patron_saint_id: e.target.id,
                                    })
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
            {
                label: 'fullname',
                name: 'fullname',
                isRequired: true,
                component: ({name, value, form, onChange}) => (
                    <Translate>
                        {(t) => (
                            <div className="flex flex-col gap-1">
                                <Space.Compact
                                    compact
                                    style={{display: 'inline-flex', alignItems: 'center'}}
                                    className="custom-input-group">
                                    <Input
                                        name={name}
                                        value={value}
                                        onChange={onChange}
                                        allowClear={true}
                                        placeholder={t('Enter your name')}
                                        style={{borderRadius: '0.375rem 0 0 0.375rem'}}
                                        className="flex-1"
                                    />
                                    <UserLookupComponent
                                        handleApply={(userInfo) => {
                                            const {values, setValues} = form ?? {}
                                            const {
                                                name,
                                                email,
                                                gender,
                                                phone_number,
                                                identifier_type,
                                                identifier_code,
                                                date_of_birth,
                                                place_of_birth,
                                                address,
                                                patron_saint,
                                                patron_saint_name,
                                                parish,
                                                parish_name,
                                                diocese,
                                                diocese_name,
                                                religious_order,
                                            } = userInfo ?? {}

                                            const user_info = _.omitBy(
                                                {
                                                    email,
                                                    gender: _.find(GenderTypes, {value: gender})?.value,
                                                    date_of_birth: !!String(date_of_birth ?? '').length
                                                        ? parseDayjs(date_of_birth)
                                                        : undefined,
                                                    place_of_birth: place_of_birth ?? undefined,
                                                    fullname: !!String(name ?? '').length
                                                        ? name
                                                        : undefined,
                                                    contact_phone: phone_number
                                                        ? phone_number
                                                        : undefined,
                                                    contact_email: email ?? undefined,
                                                    contact_address: address ?? undefined,

                                                    identifier_type: _.find(IdentifierTypes, {
                                                        value: identifier_type,
                                                    })?.value,
                                                    identifier_code: !!String(identifier_code ?? '')
                                                        .length
                                                        ? identifier_code
                                                        : undefined,

                                                    // owner (không phải nguyên userInfo) - userInfo là
                                                    // response THÔ của lookup (_type:'lookup', không
                                                    // có avatar riêng), owner mới đúng shape user tiny
                                                    // thật (_type:'user') mà getTitle/getAvatar/
                                                    // getLinkToDetail cần - trước đây gán nhầm nguyên
                                                    // userInfo khiến hiển thị/link tài khoản sai.
                                                    user: userInfo?.owner,
                                                    user_id: userInfo?.id,

                                                    patron_saint: patron_saint,
                                                    patron_saint_id: patron_saint?.id,
                                                    patron_saint_name: patron_saint_name,

                                                    diocese_id: diocese?.id,
                                                    diocese_name: diocese_name,
                                                    diocese: diocese,

                                                    parish_id: parish?.id,
                                                    parish_name: parish_name,
                                                    parish: parish,

                                                    religious_order: religious_order,
                                                    religious_order_id: religious_order?.id,
                                                    religious_order_name: userInfo?.religious_order_name,
                                                },
                                                _.isUndefined
                                            )
                                            setValues({
                                                ...values,
                                                ...(user_info ?? {}),
                                                refreshKey: Date.now(),
                                            })
                                        }}>
                                        <Button
                                            type="primary"
                                            style={{width: 46, border: '1px solid transparent'}}
                                            icon={
                                                <RiSearch2Line
                                                    size={14}
                                                    className="hover:opacity-85 cursor-pointer"
                                                />
                                            }
                                            className="flex flex-center"
                                        />
                                    </UserLookupComponent>
                                </Space.Compact>
                                {/* Phản hồi UI rõ ràng khi ĐÃ liên kết tài khoản - trước đây chọn xong
                                    qua UserLookupComponent, form chỉ đổi mỗi chữ trong ô tên (đôi khi
                                    KHÔNG đổi gì nếu tên đã trùng sẵn), không có dấu hiệu nào khác biệt
                                    với gõ tay bình thường (bạn báo "phải có màu khác, có link đến user
                                    chứ không phải text"). */}
                                {form?.values?.user ? (
                                    <LinkedAccountBadge
                                        user={form.values.user}
                                        t={t}
                                        onUnlink={() => {
                                            form.setValues({
                                                ...form.values,
                                                user: null,
                                                user_id: null,
                                                refreshKey: Date.now(),
                                            })
                                        }}
                                    />
                                ) : (
                                    <span className="text-xs text-color-500 italic leading-tight">
                                        {`* `}
                                        {t(
                                            'click on {n} to, lookup user accounts on the {m} platform',
                                            {
                                                n: (
                                                    <RiSearch2Line
                                                        size={13}
                                                        className="mx-1 text-color-000"
                                                    />
                                                ),
                                                m: (
                                                    <span className="font-bold text-blue-600 tracking-widest">
                                                        {'Kristo Network'}
                                                    </span>
                                                ),
                                            }
                                        )}
                                    </span>
                                )}
                            </div>
                        )}
                    </Translate>
                ),
            },
        ],
    },
    date_of_birth__gender: {
        inline: true,
        className: appClassNames.inline_2,
        children: [
            {
                label: 'date of birth',
                name: 'date_of_birth',
                isRequired: true,
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value: value ? dayjs(value) : null,
                        className: 'w-full',
                        format: gConfigs.dateFormat,
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                        placeholder: `${translate('date of birth')} "DD/MM/YYYY"`,
                        // 🔹 Giới hạn ngày
                        disabledDate: (current) => {
                            const maxDate = dayjs().subtract(4, 'year')
                            const minDate = dayjs().subtract(120, 'year')

                            return (
                                current &&
                                (current > maxDate.endOf('day') ||
                                    current < minDate.startOf('day'))
                            )
                        },
                        // 🔹 mở lịch ở khoảng năm hợp lý
                        defaultPickerValue: !!!value ? dayjs().subtract(4, 'year') : undefined,
                        onChange: (date, dateString) => {
                            onChange(createValue(name, date ? dayjs(new Date(date)) : null))
                        },
                    }))
                )(DatePicker),
            },
            {
                label: 'gender',
                name: 'gender',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        onChange: (value) => {
                            onChange(createValue(name, value))
                        },
                        options: Object.values(GenderTypes)
                    }))
                )(ChipGroup),
            },
        ],
    },

    // Tách riêng place_of_birth (thông tin định danh, gộp vào Section "thông tin học viên" cùng
    // ngày sinh/giới tính/giấy tờ tùy thân - bạn góp ý 4 field này "thường là thông tin định danh 1
    // người") và occupation (KHÔNG phải thông tin định danh, ở lại Section "thông tin khác" riêng) -
    // trước đây gộp chung 1 hàng nên không tách được ra 2 Section khác nhau.
    place_of_birth: {
        children: [
            {
                label: 'place of birth',
                name: 'place_of_birth',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <Translate>
                            {(t) => (
                                <LookupField
                                    title={t('choose place of birth')}
                                    createIfNotExists={true}
                                    defaultValue={form?.values?.place_of_birth}
                                    selectedOption={form?.values?.birth_province}
                                    apiPath={`/lookup/province/get-by-types`}
                                    name={name}
                                    OptionWrapper={({children, ...props}) => (
                                        <div className="p-3 flex items-center gap-2 lookup-item" {...props}>
                                            {children}
                                        </div>
                                    )}
                                    renderOption={(o, i) => (
                                        <div
                                            key={i}
                                            className="flex items-center flex-1 gap-3">
                                            <div className="p-2 font-bold text-sm text-color-000 leading-tight">
                                                {o.location_name}
                                            </div>
                                        </div>
                                    )}
                                    handleChange={(e) => {
                                        form.setValues({
                                            ...form.values,
                                            place_of_birth: e.target.value,
                                        })
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },
    occupation: {
        children: [
            {
                label: 'occupation',
                name: 'occupation',
                component: createControlledFormField({
                    placeholder: 'ex: occupation',
                    autoComplete: false,
                    Component: Input,
                }),
            },
        ],
    },

    identifier: {
        inline: true,
        className: appClassNames.inline_2,
        children: [
            {
                label: 'identifier type',
                name: 'identifier_type',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        // onChange,
                        // buttonStyle: 'solid',
                        // className: 'w-full custom-radio-button',
                        // children: Object.values(IdentifierTypes).map(
                        //     ({name, value, label}) => (
                        //         <Radio.Button
                        //             style={{padding: '0px 10px'}}
                        //             key={name}
                        //             value={value}>
                        //             {translate(label)}
                        //         </Radio.Button>
                        //     )
                        // ),
                        onChange: (value) => {
                            onChange(createValue(name, value))
                        },
                        options: Object.values(IdentifierTypes)
                    }))
                )(ChipGroup),
            },
            {
                label: 'identifier code',
                name: 'identifier_code',
                component: createControlledFormField({
                    placeholder: 'identifier code',
                    Component: Input,
                }),
            },
        ],
    },
    id_validator: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        // itemClassNames: ['flex-1', ''],
        children: [
            {
                // label: 'identifier code',
                name: 'identifier_code',
                // required: true,
                className: 'flex-1',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, form, translate, onChange}) => {
                        return {
                            name,
                            onChange,
                            type: 'id code',
                            placeholder: translate('ex: id code'),
                            defaultValue: value,
                            params: {
                                ...{
                                    owner_type: form?.values?.owner_type,
                                    owner_id: form?.values?.owner_id,
                                },
                                search_type: 'user',
                                input_type: 'identifier_code',
                            },
                            handleApply: (info) => {
                                const {values, setValues} = form ?? {}
                                const {identifier_type, identifier_code} = info ?? {}
                                // Chỉ lưu để xem trước — KHÔNG gắn user/user_id vào form ngay lúc
                                // gõ. Việc gắn thật chỉ xảy ra lúc bấm Tạo mới/Lưu, xem onSubmit của
                                // CreateStudentModal/EditStudentModal.
                                const update = _.omitBy(
                                    {
                                        identifier_type: _.find(IdentifierTypes, {
                                            value: identifier_type,
                                        })?.value,
                                        identifier_code: !!String(identifier_code ?? '').length
                                            ? identifier_code
                                            : undefined,
                                        matched_user: info?.id ? info : null,
                                    },
                                    _.isUndefined
                                )
                                setValues({
                                    ...values,
                                    ...update,
                                })
                            },
                        }
                    })
                )(IdentifierCodeLookupField),
            },
            {
                // label: 'identifier type',
                name: 'identifier_type',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        onChange: (value) => {
                            onChange(createValue(name, value))
                        },
                        options: Object.values(IdentifierTypes)
                    }))
                )(ChipGroup),
            },
        ],
    },

    contact_email: {
        title: 'email',
        children: [
            {
                name: 'contact_email',
                component: createControlledFormField({
                    type: 'email',
                    placeholder: 'ex: email',
                    autoComplete: false,
                    Component: Input,
                }),
            },
        ],
    },
    contact_phone: {
        title: 'phone',
        children: [
            {
                name: 'contact_phone',
                component: createPhoneNumberField({
                    placeholder: 'ex: phone',
                    autoComplete: false,
                    Component: Input,
                }),
            },
        ],
    },
    contact_email__phone: {
        inline: true,
        className: appClassNames.inline_2,
        description: 'student contact email hint',
        desClassName: 'text-xs text-color-400 italic mt-1.5 leading-relaxed',
        children: [
            {
                label: 'email',
                name: 'contact_email',
                component: createControlledFormField({
                    type: 'email',
                    placeholder: 'ex: email',
                    autoComplete: false,
                    Component: Input,
                }),
            },
            {
                label: 'phone',
                name: 'contact_phone',
                component: createPhoneNumberField({
                    placeholder: 'ex: phone',
                    autoComplete: false,
                    Component: Input,
                }),
            },
        ],
    },
    contact_address: {
        title: 'address',
        children: [
            {
                name: 'contact_address',
                component: createControlledFormField({
                    showCount: true,
                    maxLength: 500,
                    placeholder: 'ex: address',
                    autoComplete: false,
                    Component: Input,
                }),
            },
        ],
    },

    active: {
        // title: 'active',
        children: [
            {
                name: 'active',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        onChange: (value) => {
                            onChange(createValue(name, value))
                        },
                        options: [
                            {label: 'active', value: 1},
                            {label: 'inactive', value: 0},
                        ]
                    }))
                )(ChipGroup),
            },
        ]
    },

    diocese_location: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        children: [
            {
                // label: 'belong to parish',
                name: 'parish',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <LayoutContext.Consumer>
                            {({isSm}) => (
                                <Translate>
                                    {(t) => (
                                        <LookupField
                                            title={t('choose parish')}
                                            createIfNotExists={true}
                                            defaultValue={form?.values?.parish_name}
                                            selectedOption={form?.values?.parish}
                                            placeholder={t('choose parish')}
                                            apiPath={`/lookup/parish/get-by-types`}
                                            name={name}
                                            OptionWrapper={({children, ...props}) => (
                                                <div className="p-3 flex items-center gap-2 lookup-item" {...props}>
                                                    {children}
                                                </div>
                                            )}
                                            renderOption={(o, i) => {
                                                const {fullname, diocese_fullname, location_address} = o ?? {}
                                                return (
                                                    <div key={i} className="flex items-start flex-1 gap-3">
                                                        {renderIf(
                                                            !isSm,
                                                            <Avatar
                                                                size={40}
                                                                src={o.avatar}
                                                                className="flex flex-center bg-blue-50 rounded-lg"
                                                                icon={<MdChurch size={20} className="text-blue-500"/>}
                                                            />
                                                        )}
                                                        <div className="flex flex-col flex-1 gap-1">
                                                            <div className="space-x-1 leading-snug">
                                                                <span className="font-bold text-sm text-color-000">
                                                                    {fullname}
                                                                </span>
                                                                <span
                                                                    className="font-medium text-xs text-blue-500 italic leading-snug">
                                                                    {`( ${diocese_fullname} )`}
                                                                </span>
                                                            </div>
                                                            {renderIf(
                                                                location_address,
                                                                <div className="flex items-center gap-x-1">
                                                                    <RiMapPinFill size={11} className="text-color-400"/>
                                                                    <span
                                                                        className="flex-1 text-xs text-color-400 leading-snug tracking-wider max-lines-1">
                                                                        {location_address}
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )
                                            }}
                                            handleChange={(e) => {
                                                form.setValues({
                                                    ...form.values,
                                                    parish: e.target,
                                                    parish_name: e.target.value,
                                                    parish_id: e.target.id,
                                                    diocese: e.target.diocese,
                                                    diocese_name: e.target?.diocese?.name,
                                                    diocese_id: e.target?.diocese?.id,
                                                })
                                            }}
                                        />
                                    )}
                                </Translate>
                            )}
                        </LayoutContext.Consumer>
                    )
                },
            },
            {
                // label: 'diocese',
                name: 'diocese',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <LayoutContext.Consumer>
                            {({isSm}) => (
                                <Translate>
                                    {(t) => (
                                        <LookupField
                                            title={t('choose diocese')}
                                            placeholder={t('choose diocese')}
                                            createIfNotExists={true}
                                            defaultValue={form?.values?.diocese_name}
                                            selectedOption={form?.values?.diocese}
                                            apiPath={`/lookup/diocese/get-by-types`}
                                            name={name}
                                            OptionWrapper={({children, ...props}) => (
                                                <div className="p-3 flex items-center gap-2 lookup-item" {...props}>
                                                    {children}
                                                </div>
                                            )}
                                            renderOption={(o, i) => {
                                                const {fullname, location_address} = o ?? {}
                                                return (
                                                    <div key={i} className="flex items-start flex-1 gap-3">
                                                        {renderIf(
                                                            !isSm,
                                                            <Avatar
                                                                size={40}
                                                                src={o.avatar}
                                                                className="flex flex-center bg-blue-50 rounded-lg"
                                                                icon={<MdChurch size={20} className="text-blue-500"/>}
                                                            />
                                                        )}
                                                        <div className="flex flex-col flex-1 gap-1">
                                                            <div
                                                                className="space-x-1 font-bold text-sm text-color-000 leading-snug tracking-wide">
                                                                {fullname}
                                                            </div>
                                                            {renderIf(
                                                                location_address,
                                                                <div className="flex items-center gap-x-1">
                                                                    <RiMapPinFill size={11} className="text-color-400"/>
                                                                    <span
                                                                        className="flex-1 text-xs text-color-400 leading-snug tracking-wider max-lines-1">
                                                                        {location_address}
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )
                                            }}
                                            handleChange={(e) => {
                                                form.setValues({
                                                    ...form.values,
                                                    diocese: e.target,
                                                    diocese_name: e.target?.value,
                                                    diocese_id: e.target?.id,
                                                })
                                            }}
                                        />
                                    )}
                                </Translate>
                            )}
                        </LayoutContext.Consumer>
                    )
                },
            },
        ],
    },
    religious_order: {
        inline: true,
        className: 'grid grid-cols-1 gap-3',
        children: [
            {
                label: 'belong to religious order',
                name: 'religious_order',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <LayoutContext.Consumer>
                            {({isSm}) => (
                                <Translate>
                                    {(t) => (
                                        <LookupField
                                            title={t('choose religious orders')}
                                            createIfNotExists={true}
                                            defaultValue={form?.values?.religious_order_name}
                                            selectedOption={form?.values?.religious_order}
                                            placeholder={t('click to select / create')}
                                            apiPath={`/lookup/religious_order/get-by-types`}
                                            name={name}
                                            OptionWrapper={({children, ...props}) => (
                                                <div className="p-3 flex items-center gap-2 lookup-item" {...props}>
                                                    {children}
                                                </div>
                                            )}
                                            renderOption={(o, i) => {
                                                return (
                                                    <div key={i} className="flex items-start flex-1 gap-3">
                                                        {renderIf(
                                                            !isSm,
                                                            <Avatar
                                                                size={40}
                                                                src={o.avatar}
                                                                className="flex flex-center bg-blue-50 rounded-lg"
                                                                icon={<MdChurch size={20} className="text-blue-500"/>}
                                                            />
                                                        )}
                                                        <div className="flex flex-col gap-1 flex-1">
                                                            <span className="font-bold text-color-000 leading-tight">
                                                                {o.name}
                                                            </span>
                                                            {renderIfElse(
                                                                o?.religious_order_group,
                                                                <span
                                                                    className="font-medium text-xs text-blue-500 italic">
                                                                    {o?.religious_order_group}
                                                                </span>,
                                                                <span
                                                                    className="text-xs text-color-400 italic max-lines-2">
                                                                    {o?.description}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                )
                                            }}
                                            handleChange={(e) => {
                                                form.setValues({
                                                    ...form.values,
                                                    religious_order: e.target,
                                                    religious_order_name: e.target.value,
                                                    religious_order_id: e.target.id,
                                                })
                                            }}
                                        />
                                    )}
                                </Translate>
                            )}
                        </LayoutContext.Consumer>
                    )
                },
            },
        ],
    },

    father_user: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-3 gap-3',
        itemClassNames: ['col-span-1 md:col-span-2', 'col-span-1'],
        children: [
            {
                // label: 'first person',
                name: 'father_name',
                component: ({name, value, form, onChange}) => (
                    <Translate>
                        {(t) => (
                            <div className="flex flex-col gap-1">
                                <Space.Compact
                                    style={{display: 'inline-flex', alignItems: 'center'}}
                                    className="custom-input-group">
                                    <Input
                                        name={name}
                                        value={value}
                                        onChange={onChange}
                                        autoComplete={false}
                                        allowClear={true}
                                        placeholder={t('Enter your name')}
                                        style={{borderRadius: '0.375rem 0 0 0.375rem'}}
                                        className="flex-1"
                                    />
                                    <UserLookupComponent
                                        handleApply={(userInfo) => {
                                            const {values, setValues} = form ?? {}
                                            const {name, phone_number} = userInfo ?? {}

                                            const user_info = _.omitBy(
                                                {
                                                    father_name: !!String(name ?? '').length
                                                        ? name
                                                        : undefined,
                                                    father_phone_number: phone_number
                                                        ? phone_number
                                                        : undefined,
                                                    // owner, không phải nguyên userInfo - xem comment
                                                    // giải thích ở field fullname phía trên.
                                                    father_user: userInfo?.owner,
                                                    father_user_id: userInfo?.id,
                                                },
                                                _.isUndefined
                                            )
                                            setValues({
                                                ...values,
                                                ...(user_info ?? {}),
                                                refreshKey: Date.now(),
                                            })
                                        }}>
                                        <Button
                                            type="primary"
                                            style={{width: 46, border: '1px solid transparent'}}
                                            icon={
                                                <RiSearch2Line
                                                    size={14}
                                                    className="hover:opacity-85 cursor-pointer"
                                                />
                                            }
                                            className="flex flex-center"
                                        />
                                    </UserLookupComponent>
                                </Space.Compact>
                                <span className="text-xs text-color-500 italic leading-tight">
                                    {`* `}
                                    {t(
                                        'click on {n} to, lookup user accounts on the {m} platform',
                                        {
                                            n: (
                                                <RiSearch2Line size={13} className="mx-1 text-color-000"/>
                                            ),
                                            m: (
                                                <span className="font-bold text-blue-600 tracking-widest">
                                                    {'Kristo Network'}
                                                </span>
                                            ),
                                        }
                                    )}
                                </span>
                            </div>
                        )}
                    </Translate>
                ),
            },
            {
                // label: 'phone',
                name: 'father_phone_number',
                component: createPhoneNumberField({
                    prefix: <FaPhone size={12} className="text-slate-400"/>,
                    placeholder: 'ex: phone',
                    Component: Input,
                    autoComplete: false,
                }),
            },
        ],
    },
    mother_user: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-3 gap-3',
        itemClassNames: ['col-span-1 md:col-span-2', 'col-span-1'],
        children: [
            {
                // label: 'second person',
                name: 'mother_name',
                component: ({name, value, form, onChange}) => (
                    <Translate>
                        {(t) => (
                            <div className="flex flex-col gap-1">
                                <Space.Compact
                                    compact
                                    style={{display: 'inline-flex', alignItems: 'center'}}
                                    className="custom-input-group">
                                    <Input
                                        name={name}
                                        value={value}
                                        onChange={onChange}
                                        allowClear={true}
                                        autoComplete={false}
                                        placeholder={t('Enter your name')}
                                        style={{borderRadius: '0.375rem 0 0 0.375rem'}}
                                        className="flex-1"
                                    />
                                    <UserLookupComponent
                                        handleApply={(userInfo) => {
                                            const {values, setValues} = form ?? {}
                                            const {name, phone_number} = userInfo ?? {}

                                            const user_info = _.omitBy(
                                                {
                                                    mother_name: !!String(name ?? '').length
                                                        ? name
                                                        : undefined,
                                                    mother_phone_number: phone_number
                                                        ? phone_number
                                                        : undefined,
                                                    // owner, không phải nguyên userInfo - xem comment
                                                    // giải thích ở field fullname phía trên.
                                                    mother_user: userInfo?.owner,
                                                    mother_user_id: userInfo?.id,
                                                },
                                                _.isUndefined
                                            )
                                            setValues({
                                                ...values,
                                                ...(user_info ?? {}),
                                                refreshKey: Date.now(),
                                            })
                                        }}>
                                        <Button
                                            type="primary"
                                            style={{width: 46, border: '1px solid transparent'}}
                                            icon={
                                                <RiSearch2Line
                                                    size={14}
                                                    className="hover:opacity-85 cursor-pointer"
                                                />
                                            }
                                            className="flex flex-center"
                                        />
                                    </UserLookupComponent>
                                </Space.Compact>
                                <span className="text-xs text-color-500 italic leading-tight">
                                    {`* `}
                                    {t(
                                        'click on {n} to, lookup user accounts on the {m} platform',
                                        {
                                            n: (
                                                <RiSearch2Line size={13} className="mx-1 text-color-000"/>
                                            ),
                                            m: (
                                                <span className="font-bold text-blue-600 tracking-widest">
                                                    {'Kristo Network'}
                                                </span>
                                            ),
                                        }
                                    )}
                                </span>
                            </div>
                        )}
                    </Translate>
                ),
            },
            {
                // label: 'phone',
                name: 'mother_phone_number',
                component: createPhoneNumberField({
                    prefix: <FaPhone size={12} className="text-slate-400"/>,
                    placeholder: 'ex: phone',
                    Component: Input,
                    autoComplete: false,
                }),
            },
        ],
    },
}

function validateName(name, requireField, keyName, t) {
    const error = {}
    const maxLengthConfig = {
        fullname: 120,
        patron_saint: 180,
        father_name: 255,
        mother_name: 255,
    }
    if (!name && !requireField) return error
    const maxLength = maxLengthConfig[keyName]
    const rules = [
        requireField ? required(t) : null,
        lengthBetween(2, maxLength, t),
        noNumber(t),
        noSpecialChars(t),
        noLeadingTrailingSpaces(t),
        noDoubleSpaces(t),
        firstLetterUppercase(t),
    ].filter(Boolean)
    const message = runRules(name, rules)
    if (message) {
        error[keyName] = message
    }
    return error
}

const validateBirthday = (birthday, requireField, keyName, t) => {
    const error = {}

    if (!birthday && !requireField) return error

    const rules = [
        requireField ? required(t) : null,
        validDate(t),
        notFutureDate(t),
        minimumAge(4, t),      // ví dụ: ít nhất 4 tuổi
        maximumAge(80, t),    // ví dụ: không quá 80 tuổi
    ].filter(Boolean)

    const message = runRules(birthday, rules)

    if (message) {
        error[keyName] = message
    }

    return error
}

const validateEmail = (email, t) => {
    if (!email) return {}
    const rules = [lengthBetween(5, 120, t), emailFormat(t)]
    const error = runRules(email, rules)
    return error ? {contact_email: error} : {}
}

const validatePhoneNumber = (phone, keyName, t) => {
    if (!phone) return {}
    const rules = [digitLength(10, 16, t)]
    const error = runRules(phone, rules)
    return error ? {[keyName]: error} : {}
}

const validateAddress = (address, t) => {
    if (!address) return {}
    const rules = [
        lengthBetween(5, 500, t),
        noLeadingTrailingSpaces(t),
        noDoubleSpaces(t),
    ]
    const error = runRules(address, rules)
    return error ? {contact_address: error} : {}
}

const validateParishOrDioceseOrReligiousOrPlaceOfBirthName = (name, keyName, t) => {
    const maxLengthConfig = {
        parish: 180,
        place_of_birth: 120,
        diocese: 255,
        religious_order: 255,
    }
    if (!name) return {}
    let maxLength = maxLengthConfig[keyName]
    const rules = [
        lengthBetween(2, maxLength, t),
        noNumber(t),
        noSpecialChars(t),
        noLeadingTrailingSpaces(t),
        noDoubleSpaces(t),
        parishFormart(t),
    ]
    const error = runRules(name, rules)
    return error ? {[keyName]: error} : {}
}

const validateIdentityOrDriverLisenceOrPassport = (value, type, t) => {
    if (!value) return {identifier_code: t('required')}
    const rules =
        type === 'identitycard' || type === 'driverlicense'
            ? [digitLength(12, 50, t)]
            : [passportFormart(t)]
    const error = runRules(value, rules)
    return error ? {identifier_code: error} : {}
}

const validateCreateAndEditStudent = (t) => (values) => {
    const {
        patron_saint,
        fullname,
        parish,
        diocese,
        religious_order,
        place_of_birth, date_of_birth,
        identifier_type,
        identifier_code,
        contact_email,
        contact_phone,
        contact_address,
        father_name,
        mother_name,
        father_phone_number,
        mother_phone_number,
    } = values ?? {}
    const errorPatronSaint = validateName(
        patron_saint ? patron_saint.value : '',
        false,
        'patron_saint',
        t
    )
    const errorFullname = validateName(fullname, true, 'fullname', t)
    const errorParish = validateParishOrDioceseOrReligiousOrPlaceOfBirthName(
        parish ? parish.value : '',
        'parish',
        t
    )
    const errorDiocese = validateParishOrDioceseOrReligiousOrPlaceOfBirthName(
        diocese ? diocese.value : '',
        'diocese',
        t
    )
    const errorReligious = validateParishOrDioceseOrReligiousOrPlaceOfBirthName(
        religious_order ? religious_order.value : '',
        'religious_order',
        t
    )
    // const errorIdentity = validateIdentityOrDriverLisenceOrPassport(
    //     identifier_code,
    //     identifier_type,
    //     t
    // )
    const errorDateOfBirth =
        validateBirthday(
            date_of_birth,
            true,
            'date_of_birth',
            t
        )
    const errorPlaceOfBirth =
        validateParishOrDioceseOrReligiousOrPlaceOfBirthName(
            place_of_birth,
            'place_of_birth',
            t
        )
    const errorEmail = validateEmail(contact_email, t)
    const errorPhoneNumber = validatePhoneNumber(
        contact_phone,
        'contact_phone',
        t
    )
    const errorAddress = validateAddress(contact_address, t)
    const errorFatherName = validateName(father_name, false, 'father_name', t)
    const errorMotherName = validateName(mother_name, false, 'mother_name', t)
    const errorFatherPhoneNumber = validatePhoneNumber(
        father_phone_number,
        'father_phone_number',
        t
    )
    const errorMotherPhoneNumber = validatePhoneNumber(
        mother_phone_number,
        'mother_phone_number',
        t
    )
    return {
        ...errorPatronSaint,
        ...errorFullname,
        ...errorParish,
        ...errorDiocese,
        ...errorReligious,
        ...errorPlaceOfBirth,
        ...errorDateOfBirth,
        // ...errorIdentity,
        ...errorEmail,
        ...errorPhoneNumber,
        ...errorAddress,
        ...errorFatherName,
        ...errorMotherName,
        ...errorFatherPhoneNumber,
        ...errorMotherPhoneNumber,
    }
}

export const CreateStudentModal = ({
                                       owner_id,
                                       owner_type,
                                       onCancel = NullAsDefault,
                                       onSubmit = NullAsDefault,
                                   }) => {
    const t = useTranslate()

    const initialValues = useMemo(() => {
        return {
            owner_id,
            owner_type,
            avatar: undefined,
            contact_email: undefined,
            // identifier_type: 'identitycard',
            gender: 3,
            refreshKey: Date.now(),
        }
    }, [owner_id, owner_type])

    return (
        <Formik
            validate={validateCreateAndEditStudent(t)}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={(values) => {
                const {email, owner_id, owner_type, matched_user, ...rest} = values ?? {}
                onSubmit({
                    ...rest,
                    // Chỉ gắn user/user_id từ tra cứu mã định danh nếu vừa tìm ra kết quả mới —
                    // không đụng tới nếu rest.user/user_id đã được chọn qua ô tìm theo tên (nơi đó
                    // vẫn yêu cầu bấm "Chọn" tường minh, không cần sửa).
                    ...(matched_user ? {user: matched_user, user_id: matched_user.id} : {}),
                })
            }}>
            {({values}) => {
                const {user, refreshKey} = values ?? {}

                return (
                    <ActionModalWrapper action={<FormActionBar submitText="create"/>}>
                        <Pure input={[refreshKey]}>
                            <div
                                key={refreshKey}
                                className="flex flex-col gap-6">
                                <Section icon={FaUserGraduate} title={t('student information')}>
                                    <FieldsFactory
                                        formSchema={[
                                            formSchema.patron_saint__fullname,
                                            formSchema.date_of_birth__gender,
                                        ]}
                                    />
                                </Section>
                                <Section icon={FaPhone} title={t('contact information')}>
                                    <FieldsFactory
                                        formSchema={[
                                            formSchema.contact_email__phone,
                                            formSchema.contact_address,
                                        ]}
                                    />
                                </Section>
                                <Section icon={BsPeopleFill} title={t('parent information')} subtitle={t('parent guardian section hint')}>
                                    <Field label={t('first person')}>
                                        <FieldsFactory formSchema={[formSchema.father_user]}/>
                                    </Field>
                                    <Field label={t('second person')}>
                                        <FieldsFactory formSchema={[formSchema.mother_user]}/>
                                    </Field>
                                </Section>
                            </div>
                        </Pure>
                    </ActionModalWrapper>
                )
            }}
        </Formik>
    )
}

export const EditStudentModal = ({
                                     item,
                                     owner_id,
                                     owner_type,
                                     onCancel = NullAsDefault,
                                     onSubmit = NullAsDefault,
                                 }) => {
    const t = useTranslate()

    const initialValues = useMemo(() => {
        const {date_of_birth, avatar, ...rest} = item ?? {}

        return {
            ...rest,
            owner_id,
            owner_type,
            avatar_preview: avatar,
            date_of_birth: parseDayjs(date_of_birth),
            // Khớp với dữ liệu đang liên kết sẵn có (giống TeacherForm.js) - để field "giấy tờ tùy
            // thân" tự re-verify khi mount (IdentifierCodeLookupField) không bị coi là "vừa sửa" nếu
            // kết quả giống hệt lúc mở form (vd cả 2 đều null vì học viên chưa liên kết tài khoản).
            // Thiếu dòng seed này thì MỌI lần mở form sửa đều bị tính là "vừa sửa mã định danh" ngay
            // từ lúc mount, khiến submit tự động gỡ mất user/user_id vừa chọn qua ô tìm theo tên phía
            // trên dù người dùng chưa hề đụng tới field giấy tờ tùy thân (bạn báo "gõ xuống đó ... reset
            // bên trên").
            matched_user: rest?.user?.id ? rest.user : null,
            parish: _.get(rest, 'parish', ''),
            parish_id: _.get(rest, 'parish.id', ''),
            parish_name: _.get(rest, 'parish_name', ''),
            patron_saint: rest?.patron_saint,
            patron_saint_id: rest?.patron_saint?.id,
            patron_saint_name:
                rest?.patron_saint_name || rest?.patron_saint?.common_name,
            religious_order: rest?.religious_order,
            religious_order_id: rest?.religious_order?.id,
            religious_order_name:
                rest?.religious_order_name || rest?.religious_order?.title,
            place_of_birth: rest?.place_of_birth,
            occupation: rest?.occupation,

            father_user: rest?.father?.user,
            father_user_id: rest?.father?.user?.id,
            father_name: rest?.father?.user?.name || rest?.father?.name,
            father_phone_number: rest?.father?.user?.name || rest?.father?.phone,

            mother_user: rest?.mother?.user,
            mother_user_id: rest?.mother?.user?.id,
            mother_name: rest?.mother?.user?.name || rest?.mother?.name,
            mother_phone_number: rest?.mother?.user?.name || rest?.mother?.phone,
        }
    }, [item, owner_id, owner_type])

    return (
        <Formik
            validate={validateCreateAndEditStudent(t)}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={(values) => {
                // "user"/"user_id" (tài khoản liên kết) tách HẲN khỏi shallowDiff, KHÔNG lấy qua
                // changesRest nữa - bug cũ: chọn tài khoản qua ô tìm "Tên đầy đủ" (UserLookupComponent,
                // ghi thẳng values.user/user_id lúc bấm "Chọn") xong bấm Lưu thì user/user_id vẫn gửi
                // null lên server (bạn báo lỗi "chọn user rồi nhưng không ghi nhận"). Đường tra cứu đó
                // KHÔNG đụng tới matched_user (field riêng của IdentifierCodeLookupField ở dưới) nên
                // logic cũ chỉ gắn user/user_id khi "matched_user" nằm trong diff đã bỏ sót hẳn trường
                // hợp chọn qua tên/email - giờ đọc THẲNG values.user/user_id (giá trị submit-time thật,
                // không qua diff) và so trực tiếp với user ban đầu để quyết định có gửi hay không.
                const {email, owner_id, owner_type, matched_user, user, user_id, ...rest} = values ?? {}
                const _values = {
                    ...rest,
                }

                const changes = shallowDiff(_values, initialValues)
                const initialUserId = initialValues?.user?.id ?? null
                // matched_user bị tách khỏi _values ở trên (không còn nằm trong `changes` nữa) nên
                // phải tự so trực tiếp với giá trị ban đầu ở đây, không dò qua `changes` được nữa.
                const identifierChanged = JSON.stringify(matched_user ?? null)
                    !== JSON.stringify(initialValues?.matched_user ?? null)

                let userPatch = {}
                if (identifierChanged) {
                    // Mã định danh vừa được sửa trong lượt này - ưu tiên kết quả tra cứu theo mã định
                    // danh (khớp ai → ghi đè bằng người đó; không khớp ai → gửi null tường minh để gỡ
                    // liên kết cũ, không dùng undefined vì sẽ bị _.omitBy bên dưới lọc mất).
                    userPatch = {user: matched_user || null, user_id: matched_user?.id ?? null}
                } else if ((user_id ?? null) !== initialUserId) {
                    // Không đụng mã định danh nhưng user/user_id (qua ô tìm tên/email) đã khác giá trị
                    // ban đầu - đây chính là case bị bỏ sót trước đây.
                    userPatch = {user: user ?? null, user_id: user_id ?? null}
                }

                onSubmit(
                    _.omitBy(
                        {
                            ...changes,
                            ...userPatch,
                        },
                        _.isUndefined
                    )
                )
            }}>
            {({values}) => {
                const {user, refreshKey, identity_status} = values ?? {}
                const isIdentityVerified = (identity_status ?? IDENTITY_STATUS.UNVERIFIED) === IDENTITY_STATUS.VERIFIED
                return (
                    <Pure input={[refreshKey]}>
                        <React.Fragment key={values?.refreshKey}>
                            <ActionModalWrapper action={<FormActionBar submitText="save"/>} className="gap-4">
                                {/* Ảnh đại diện đứng riêng 1 dòng/Section như convention chung (xem
                                    ProfileForm.js) - trước gộp chung cột với Section thông tin học
                                    viên khiến block đầu dày đặc, bạn góp ý tách hẳn ra. */}
                                <Section icon={IoImageOutline} title={t('avatar')}>
                                    <div className="flex flex-col md:flex-row gap-4">
                                        {/* Uploader hiện tại - GIỮ NGUYÊN (nút "Ảnh đại diện" không đổi) */}
                                        <div className="flex-shrink-0">
                                            <FieldsFactory formSchema={[formSchema.avatar]}/>
                                        </div>
                                        {/* Thông tin quy cách ảnh - thiết kế theo mockup */}
                                        <div className="flex flex-col gap-2 flex-1 min-w-0">
                                            <div className="flex items-start justify-between gap-2">
                                                <span className="text-xs font-medium text-color-200 tracking-wider">
                                                    {t('student portrait photo')}
                                                </span>
                                                {/*{isIdentityVerified && (*/}
                                                {/*    <span className="flex-shrink-0 flex items-center gap-1 px-2 py-0.5 rounded-full border border-green-200">*/}
                                                {/*        <span className="w-1.5 h-1.5 rounded-full bg-green-500 flex-shrink-0"/>*/}
                                                {/*        <span className="text-2xs font-medium text-green-600 whitespace-no-wrap">*/}
                                                {/*            {t('identity verified')}*/}
                                                {/*        </span>*/}
                                                {/*    </span>*/}
                                                {/*)}*/}
                                            </div>
                                            <p className="text-xs text-color-300 leading-relaxed tracking-wider">
                                                {t('student portrait photo hint')}
                                            </p>
                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-1.5 p-3 background border border-color-50 rounded-xl">
                                                {[
                                                    {icon: <BsInfoCircle size={12} className="text-blue-500 flex-shrink-0"/>, label: t('avatar format hint')},
                                                    {icon: <BsAspectRatio size={12} className="text-indigo-500 flex-shrink-0"/>, label: t('avatar ratio hint')},
                                                    {icon: <BsExclamationTriangleFill size={12} className="text-rose-500 flex-shrink-0"/>, label: t('avatar max size hint')},
                                                    {icon: <BsShieldCheck size={12} className="text-rose-500 flex-shrink-0"/>, label: t('avatar auto optimize hint')},
                                                ].map(({icon, label}, i) => (
                                                    <span key={i} className="flex items-center gap-1.5 text-2xs text-color-300 tracking-wider whitespace-no-wrap">
                                                        {icon}
                                                        {label}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </Section>

                                {/* Ngày sinh/nơi sinh/giới tính/giấy tờ tùy thân gộp CHUNG 1 Section
                                    (bạn góp ý 4 field này "thường là thông tin định danh 1 người",
                                    trước đây bị tách rải rác 3 Section khác nhau) - giới tính giữ
                                    nguyên vị trí ngay sau ngày sinh (bạn yêu cầu "vẫn để ở trên"), giấy
                                    tờ tùy thân xuống cuối kèm hint giải thích tự động liên kết tài
                                    khoản (trước là subtitle riêng của Section giờ không còn tách nữa,
                                    chuyển thành dòng chú thích ngay dưới field). */}
                                <Section icon={FaUserGraduate} title={t('student information')}>
                                    <FieldsFactory
                                        formSchema={[
                                            formSchema.patron_saint__fullname,
                                            formSchema.date_of_birth__gender,
                                            formSchema.place_of_birth,
                                        ]}
                                    />
                                    <Field label={t('identification documents')}>
                                        <FieldsFactory formSchema={[formSchema.id_validator]}/>
                                        <span className="text-2xs text-color-300 italic tracking-wider">
                                            {t('id lookup guidance')}
                                        </span>
                                    </Field>
                                </Section>

                                {/* Nghề nghiệp KHÔNG phải thông tin định danh - ở lại Section riêng,
                                    tách khỏi nơi sinh (trước đây gộp chung 1 hàng với nơi sinh). */}
                                <Section icon={BsInfoCircle} title={t('other information')}>
                                    <FieldsFactory formSchema={[formSchema.occupation]}/>
                                </Section>

                                {/* Giáo xứ/giáo phận + dòng tu gộp chung 1 Section "thông tin tôn
                                    giáo" (cùng nhóm gốc gác/mục vụ, tách khỏi "thông tin khác" phía
                                    trên). */}
                                <Section icon={MdChurch} title={t('religious information')}>
                                    <FieldsFactory formSchema={[formSchema.diocese_location]}/>
                                    <FieldsFactory formSchema={[formSchema.religious_order]}/>
                                </Section>

                                <Section icon={FaPhone} title={t('contact information')}>
                                    <FieldsFactory
                                        formSchema={[
                                            formSchema.contact_email__phone,
                                            formSchema.contact_address,
                                        ]}
                                    />
                                </Section>

                                <Section icon={BsPeopleFill} title={t('parent information')} subtitle={t('parent guardian section hint')}>
                                    <Field label={t('first person')}>
                                        <FieldsFactory formSchema={[formSchema.father_user]}/>
                                    </Field>
                                    <Field label={t('second person')}>
                                        <FieldsFactory formSchema={[formSchema.mother_user]}/>
                                    </Field>
                                </Section>

                                {/* Trạng thái hoạt động trước đây là 1 Field trần đứng rời ngoài mọi
                                    Section (bạn báo "rời rạc") - giờ có khối/nền riêng như các nhóm
                                    khác, theme highlight vì đây là field ảnh hưởng trực tiếp tới việc
                                    học viên còn hiển thị/hoạt động hay không. */}
                                <Section icon={BsCheckCircleFill} title={t('active')} theme="highlight">
                                    <FieldsFactory formSchema={[formSchema.active]}/>
                                </Section>
                            </ActionModalWrapper>
                        </React.Fragment>
                    </Pure>
                )
            }}
        </Formik>
    )
}

export const EditStudentPersonalForm = ({
                                            item,
                                            onCancel = NullAsDefault,
                                            onSubmit = NullAsDefault,
                                        }) => {
    const t = useTranslate()

    const initialValues = useMemo(() => {
        const {date_of_birth, avatar, ...rest} = item ?? {}

        return {
            avatar_preview: avatar,
        }
    }, [item])

    const validate = (values) => {
        let errors = {}
        const {avatar} = values ?? {}
        if (_.isEmpty(avatar ?? '')) {
            errors.avatar = t('required field')
        }
        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={(values) => {
                const changes = shallowDiff(values, initialValues)
                onSubmit(
                    _.omitBy(
                        {
                            ...changes,
                        },
                        _.isUndefined
                    )
                )
            }}>
            {({values}) => {
                const {user, refreshKey} = values ?? {}

                return (
                    <Pure input={[refreshKey]}>
                        <React.Fragment key={values?.refreshKey}>
                            <ActionModalWrapper
                                action={<FormActionBar submitText="save"/>}
                                className="gap-4">
                                <div className="p-3 border-l-4 border-color-300 rounded-lg shadow">
                                    <div
                                        className="mb-4 flex items-center font-bold text-lg text-gray-800 uppercase tracking-wide">
                                        <BsPersonCircle
                                            size={20}
                                            className="mr-2 text-color-500"
                                        />
                                        {t('image')}
                                    </div>
                                    <FieldsFactory formSchema={[formSchema.avatar]}/>
                                </div>
                            </ActionModalWrapper>
                        </React.Fragment>
                    </Pure>
                )
            }}
        </Formik>
    )
}
